<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Заболевания пациента</h1>
      </v-col>

      <v-col align="right">
        <modal depressed icon="add" title="Добавить заболевание" name="Заболевание" component="add-diseases"></modal>
      </v-col>
    </v-row>

    <patient-header />
    <diseases />
  </v-container>
</template>

<script>
import Diseases from "@/views/pages/diseases/components/Diseases";
import Modal from "@/components/Modal";

import PatientHeader from "@/components/PatientHeader";
export default {
  name: "DiseasesList",

  components: {
    Diseases,
    Modal,
    PatientHeader,
  },
};
</script>

<style scoped></style>
